var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7V0.46C12.913 0.806 13.753 1.339 14.465 2.05L17.949 5.536C18.661 6.247 19.194 7.087 19.54 8H13C12.448 8 12 7.551 12 7ZM19.976 10H13C11.346 10 10 8.654 10 7V0.024C9.839 0.013 9.678 0 9.515 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H15C17.757 24 20 21.757 20 19V10.485C20 10.322 19.987 10.161 19.976 10ZM13 18H11V20C11 20.552 10.552 21 10 21C9.448 21 9 20.552 9 20V18H7C6.448 18 6 17.552 6 17C6 16.448 6.448 16 7 16H9V14C9 13.448 9.448 13 10 13C10.552 13 11 13.448 11 14V16H13C13.552 16 14 16.448 14 17C14 17.552 13.552 18 13 18Z",
    fill: "#55217E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.1504a8f3.svg";
export { ForwardRef as ReactComponent };